import { __decorate } from "tslib";
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { ApiAttachmentConstants } from "../../../../constants/api-constants/api-attachment.constants";
import { ApiLookupConstants } from "../../../../constants/api-constants/api-lookup.constants";
let AttachmentManagerService = class AttachmentManagerService {
    http;
    emitSelectedSavedAttachment = new EventEmitter();
    emitSavedAttachment = new EventEmitter();
    emitListUpdated = new EventEmitter();
    emitClearAttachment = new EventEmitter();
    emitClearAttachmentTable = new EventEmitter();
    constructor(http) {
        this.http = http;
    }
    getAttachments(appId, attachmentType) {
        let _filter = "";
        if (attachmentType && attachmentType.length > 0)
            _filter = `and attachmentType eq '${attachmentType}'`;
        const params = {
            $filter: `jobId eq ${appId} ${_filter} `,
        };
        return this.http
            .get(ApiAttachmentConstants.URL, { params })
            .pipe(map((res) => {
            return res.value;
        }));
    }
    getAttachmentTypeLookup(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} and name eq 'AttachmentType'`,
        };
        return this.http
            .get(ApiLookupConstants.URL, { params })
            .pipe(map((res) => {
            return res.value;
        }));
    }
    uploadAttachment(document, key) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${key}/${ApiAttachmentConstants.FUNCTION_UPLOAD_ATTACHMENT}`, document);
    }
    uploadProjectCycleAttachment(document) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_UPLOAD_PROJECT_CYCLE_DOCUMENT}`, document);
    }
    getAttachmentContent(key) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${key}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    deleteMultiple(model) {
        return this.http.post(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.FUNCTION_DELETE_MULTIPLE_ATTACHMENTS}`, model);
    }
    selectSavedAttachment(attachment) {
        this.emitSelectedSavedAttachment.emit(attachment);
    }
    addSavedAttachment(attachment) {
        this.emitSavedAttachment.emit(attachment);
    }
    listUpated(attachments) {
        this.emitListUpdated.emit(attachments);
    }
    //  public addSavedAttachment(): void {
    //   this.emitSavedAttachment.emit(attachment);
    // }
    getPcAttachmentAttachments(projectCycleId, moduleId) {
        const params = {
            $expand: `projectCycleAttachment`,
            $filter: `projectCycleAttachment/projectCycleId eq ${projectCycleId} and moduleId eq ${moduleId}`,
        };
        return this.http.get(`${ApiAttachmentConstants.URL}/${ApiAttachmentConstants.GET_PROJECT_CYCLE_ATTACHMENTS}`, { params }).pipe(map(x => { return x.value; }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
AttachmentManagerService = __decorate([
    Injectable({
        providedIn: "root",
    })
], AttachmentManagerService);
export { AttachmentManagerService };
